export enum EnumStatusDaInscricaoDoAlunoNaViagem {
    AGUARDANDO_INSCRICAO = 1,
    AGUARDANDO_PAGAMENTO = 2,
    INSCRITO_E_PAGO = 3,
    CANCELADO = 4
}

export const StatusDaInscricaoDoAlunoNaViagemDicionario:Record<EnumStatusDaInscricaoDoAlunoNaViagem, string> = {
    [EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO] : "Aguardando inscrição",
    [EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_PAGAMENTO] : "Aguardando pagamento",
    [EnumStatusDaInscricaoDoAlunoNaViagem.INSCRITO_E_PAGO] : "Inscrito e pago",
    [EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO] : "Cancelado"
}

export const StatusDaInscricaoDoAlunoNaViagemLista = [
    { value: EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO, label: StatusDaInscricaoDoAlunoNaViagemDicionario[EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO] },
    { value: EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_PAGAMENTO, label: StatusDaInscricaoDoAlunoNaViagemDicionario[EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_PAGAMENTO] },
    { value: EnumStatusDaInscricaoDoAlunoNaViagem.INSCRITO_E_PAGO, label: StatusDaInscricaoDoAlunoNaViagemDicionario[EnumStatusDaInscricaoDoAlunoNaViagem.INSCRITO_E_PAGO] },
    { value: EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO, label: StatusDaInscricaoDoAlunoNaViagemDicionario[EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO] },
];